export enum GuardianStatusEnum {
  Bound = 'bound',
  Pending = 'pending',
}
